//le footer avec les icones de reseaux sociaux
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
  faInstagram,
 
} from "@fortawesome/free-brands-svg-icons";
import "./footer.css";
import maltIcon from "../../assets/images/malt-svgrepo-com.svg"; // Import the Malt SVG icon

const openLinkInNewTab = (url) => {
  window.open(url, "_blank");
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-social">
        <button className="button-link" name="github" onClick={() => openLinkInNewTab("https://github.com/nadia3190")}>
          <FontAwesomeIcon icon={faGithub} className="icon sparkley-icon" />
        </button>
        <button className="button-link" name="linkedin" onClick={() => openLinkInNewTab("https://www.linkedin.com/in/nadia-talbi-%F0%9F%A4%B9%E2%80%8D%E2%99%80%EF%B8%8F-247200224/")}>
          <FontAwesomeIcon icon={faLinkedin} className="icon sparkley-icon" />
        </button>
      
  <button className="button-link" name="instagram" onClick={() => openLinkInNewTab("https://www.instagram.com/nadiatalbi31/")}>
      <FontAwesomeIcon icon={faInstagram} className="icon sparkley-icon" />
    </button>
      </div>
      <div className="footer-rights">
        <p>&copy; 2025 Tous droits réservés</p>
      </div>
    </footer>
  );
};

export default Footer;
